// extracted by mini-css-extract-plugin
export var smallSpinner = "_q2-0";